import { produceWithPatches } from "immer";

export function DropdownIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
    >
      <path
        d="M14 1.30003C14 1.15362 13.9378 1.00802 13.8148 0.879213C13.7031 0.76335 13.5473 0.667726 13.3622 0.601374C13.1771 0.535023 12.9688 0.500133 12.7569 0.500001L1.24285 0.5C0.811503 0.5 0.411234 0.644004 0.184995 0.879212C0.0740643 0.995331 0.0108431 1.1277 0.00127509 1.26387C-0.00829292 1.40004 0.0361067 1.53555 0.1303 1.65764L5.88734 8.05783C5.99076 8.19072 6.14961 8.30246 6.34609 8.38055C6.54258 8.45864 6.76896 8.5 6.99989 8.5C7.23082 8.5 7.4572 8.45864 7.65368 8.38055C7.85017 8.30246 8.00901 8.19072 8.11244 8.05783L13.8695 1.65764C13.9565 1.54563 14 1.42163 14 1.30003Z"
        fill="#161E2E"
      />
    </svg>
  );
}

export function PauseIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.9165 8.25C9.9165 7.83579 9.58072 7.5 9.1665 7.5C8.75229 7.5 8.4165 7.83579 8.4165 8.25V16.75C8.4165 17.1642 8.75229 17.5 9.1665 17.5C9.58072 17.5 9.9165 17.1642 9.9165 16.75V8.25ZM15.5832 8.25C15.5832 7.83579 15.2474 7.5 14.8332 7.5C14.419 7.5 14.0832 7.83579 14.0832 8.25V16.75C14.0832 17.1642 14.419 17.5 14.8332 17.5C15.2474 17.5 15.5832 17.1642 15.5832 16.75V8.25Z"
        fill={`${props.disabled?"#837a7a60":"#429E55"}`}
      />
    </svg>
  );
}

export function PlayIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4997 8.33208L15.9992 11.5847C16.6947 11.9956 16.6947 13.0028 15.9992 13.4137L10.4997 16.6663C9.79133 17.0857 8.896 16.5742 8.896 15.7512V9.24725C8.896 8.42417 9.79133 7.91275 10.4997 8.33208V8.33208Z"
        stroke={`${props.disabled?"#837a7a60":"#DE4343"}`}
      
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ResetIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4535 3.36224C11.1607 3.06928 11.1608 2.5944 11.4537 2.30158C11.7467 2.00875 12.2216 2.00886 12.5144 2.30183L14.6473 4.43571C14.7879 4.5764 14.8669 4.76718 14.8668 4.9661C14.8668 5.16501 14.7877 5.35576 14.647 5.49637L12.5143 7.62814L12.5141 7.62826C12.2212 7.92106 11.7464 7.92098 11.4535 7.62808C11.1607 7.33517 11.1607 6.86035 11.4536 6.56748L11.4537 6.56735L12.2822 5.73891C9.54333 5.63597 6.90508 6.99171 5.40985 9.37381C3.65393 12.1712 3.85796 15.7729 5.91857 18.3541C7.97917 20.9353 11.4462 21.9321 14.563 20.8395C17.6796 19.7469 19.7653 16.804 19.7637 13.5015C19.7588 11.8234 19.2063 10.1928 18.1901 8.85729C17.9393 8.52765 18.0032 8.0571 18.3328 7.80627C18.6624 7.55544 19.133 7.61933 19.3838 7.94897C20.598 9.54463 21.258 11.4931 21.2637 13.4981L21.2637 13.4998C21.2661 17.4401 18.7777 20.9515 15.0592 22.255C11.3408 23.5585 7.20463 22.3693 4.7463 19.2899C2.28797 16.2105 2.04456 11.9137 4.13939 8.57635C5.92181 5.73672 9.06571 4.11962 12.3304 4.23959L11.4535 3.36224Z"
      
        fill={`${props.disabled?"#837a7a60":"#AEC954"}`}
      />
    </svg>
  );
}

export function DisableIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3642 6.13599L5.63623 18.864L18.3642 6.13599Z"
        stroke={`${props.disabled?"#837a7a60":"#E79154"}`}

        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.5V3.5C7.029 3.5 3 7.529 3 12.5V12.5C3 17.471 7.029 21.5 12 21.5V21.5C16.971 21.5 21 17.471 21 12.5V12.5C21 7.529 16.971 3.5 12 3.5Z"
        stroke={`${props.disabled?"#837a7a60":"#E79154"}`}
      
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function PlusIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M11.5 18.707V6.29321"
        stroke="#AEC954"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.29297 12.5H17.7068"
        stroke="#AEC954"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ActiveStepIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
    >
      <path
        d="M36.5 18C36.5 8.05887 28.4411 0 18.5 0C8.55887 0 0.5 8.05887 0.5 18C0.5 27.9411 8.55887 36 18.5 36C28.4411 36 36.5 27.9411 36.5 18ZM3.02 18C3.02 9.45063 9.95063 2.52 18.5 2.52C27.0494 2.52 33.98 9.45063 33.98 18C33.98 26.5494 27.0494 33.48 18.5 33.48C9.95063 33.48 3.02 26.5494 3.02 18Z"
        fill="#D6D6D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 18.2604C22.5 19.2229 23.2875 20.0104 24.25 19.9999C25.2125 19.9999 26 19.2124 26 18.2499C26 17.2875 25.2125 16.5 24.25 16.5C23.2875 16.5 22.5 17.2875 22.5 18.2604Z"
        fill="#D6D6D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 18.2604C17 19.2229 17.7875 20.0104 18.75 19.9999C19.7125 19.9999 20.5 19.2124 20.5 18.2499C20.5 17.2875 19.7125 16.5 18.75 16.5C17.7875 16.5 17 17.2875 17 18.2604Z"
        fill="#D6D6D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 18.2604C11.5 19.2229 12.2875 20.0104 13.25 19.9999C14.2125 19.9999 15 19.2124 15 18.2499C15 17.2875 14.2125 16.5 13.25 16.5C12.2875 16.5 11.5 17.2875 11.5 18.2604Z"
        fill="#D6D6D6"
      />
      <path
        d="M18.5 1C18.5 0.447717 18.9482 -0.0028984 19.4996 0.0277527C23.9092 0.272832 28.0886 2.13279 31.2279 5.27208C34.6036 8.64773 36.5 13.2261 36.5 18C36.5 22.7739 34.6036 27.3523 31.2279 30.7279C28.0886 33.8672 23.9092 35.7272 19.4996 35.9722C18.9482 36.0029 18.5 35.5523 18.5 35L18.5 33.4C18.5 32.8477 18.9483 32.4036 19.4993 32.3653C22.9533 32.1252 26.2183 30.6464 28.6823 28.1823C31.3829 25.4818 32.9 21.8191 32.9 18C32.9 14.1809 31.3829 10.5182 28.6823 7.81766C26.2183 5.35365 22.9533 3.87481 19.4993 3.63469C18.9483 3.59638 18.5 3.15228 18.5 2.6L18.5 1Z"
        fill="#AEC954"
      />
    </svg>
  );
}

export function StepIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18ZM2.52 18C2.52 9.45063 9.45063 2.52 18 2.52C26.5494 2.52 33.48 9.45063 33.48 18C33.48 26.5494 26.5494 33.48 18 33.48C9.45063 33.48 2.52 26.5494 2.52 18Z"
        fill="#D6D6D6"
      />
    </svg>
  );
}

export function SearchIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.74609 11.5588C4.74609 8.07278 7.57205 5.24683 11.058 5.24683C14.544 5.24683 17.37 8.07278 17.37 11.5588C17.37 13.2906 16.6725 14.8596 15.5431 16C15.5356 16.007 15.5281 16.0141 15.5208 16.0214C15.5135 16.0287 15.5064 16.0362 15.4994 16.0437C14.3589 17.1732 12.7899 17.8707 11.058 17.8707C7.57205 17.8707 4.74609 15.0448 4.74609 11.5588ZM16.0263 17.5876C14.676 18.7015 12.9452 19.3707 11.058 19.3707C6.74362 19.3707 3.24609 15.8732 3.24609 11.5588C3.24609 7.24435 6.74362 3.74683 11.058 3.74683C15.3725 3.74683 18.87 7.24435 18.87 11.5588C18.87 13.4459 18.2009 15.1767 17.0869 16.5269L20.5331 19.9731C20.826 20.266 20.826 20.7408 20.5331 21.0337C20.2402 21.3266 19.7654 21.3266 19.4725 21.0337L16.0263 17.5876Z"
        fill="#50514A"
      />
    </svg>
  );
}

export function VerticalDividerIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="1"
      height="25"
      viewBox="0 0 1 25"
      fill="none"
    >
      <rect y="0.5" width="1" height="24" rx="0.5" fill="#D6D6D6" />
    </svg>
  );
}

export function CrossIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.53033 7.96967C8.23744 7.67678 7.76256 7.67678 7.46967 7.96967C7.17678 8.26256 7.17678 8.73744 7.46967 9.03033L10.9393 12.5L7.46967 15.9697C7.17678 16.2626 7.17678 16.7374 7.46967 17.0303C7.76256 17.3232 8.23744 17.3232 8.53033 17.0303L12 13.5607L15.4697 17.0303C15.7626 17.3232 16.2374 17.3232 16.5303 17.0303C16.8232 16.7374 16.8232 16.2626 16.5303 15.9697L13.0607 12.5L16.5303 9.03033C16.8232 8.73744 16.8232 8.26256 16.5303 7.96967C16.2374 7.67678 15.7626 7.67678 15.4697 7.96967L12 11.4393L8.53033 7.96967Z"
        fill="#50514A"
      />
    </svg>
  );
}

export function SortingIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3C3.27614 3 3.5 3.22386 3.5 3.5L3.5 13.5C3.5 13.7761 3.27614 14 3 14C2.72386 14 2.5 13.7761 2.5 13.5L2.5 3.5C2.5 3.22386 2.72386 3 3 3Z"
        fill="#50514A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.35355 11.1464C5.54882 11.3417 5.54882 11.6583 5.35355 11.8536L3.35355 13.8536C3.15829 14.0488 2.84171 14.0488 2.64645 13.8536L0.646447 11.8536C0.451184 11.6583 0.451184 11.3417 0.646447 11.1464C0.841709 10.9512 1.15829 10.9512 1.35355 11.1464L3 12.7929L4.64645 11.1464C4.84171 10.9512 5.15829 10.9512 5.35355 11.1464Z"
        fill="#50514A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 6.5C7 6.77614 7.22386 7 7.5 7H10.5C10.7761 7 11 6.77614 11 6.5C11 6.22386 10.7761 6 10.5 6H7.5C7.22386 6 7 6.22386 7 6.5Z"
        fill="#50514A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 9.5C7 9.77614 7.22386 10 7.5 10H12.5C12.7761 10 13 9.77614 13 9.5C13 9.22386 12.7761 9 12.5 9H7.5C7.22386 9 7 9.22386 7 9.5Z"
        fill="#50514A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 12.5C7 12.7761 7.22386 13 7.5 13H14.5C14.7761 13 15 12.7761 15 12.5C15 12.2239 14.7761 12 14.5 12H7.5C7.22386 12 7 12.2239 7 12.5Z"
        fill="#50514A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 3.5C7 3.77614 7.22386 4 7.5 4H8.5C8.77614 4 9 3.77614 9 3.5C9 3.22386 8.77614 3 8.5 3H7.5C7.22386 3 7 3.22386 7 3.5Z"
        fill="#50514A"
      />
    </svg>
  );
}

export function DeleteIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M6.74672 9.49884C6.74672 9.08463 6.41093 8.74884 5.99672 8.74884C5.58251 8.74884 5.24672 9.08463 5.24672 9.49884H6.74672ZM18.7517 9.49884C18.7517 9.08463 18.4159 8.74884 18.0017 8.74884C17.5875 8.74884 17.2517 9.08463 17.2517 9.49884H18.7517ZM14.7501 10.4993C14.7501 10.085 14.4143 9.74926 14.0001 9.74926C13.5858 9.74926 13.2501 10.085 13.2501 10.4993H14.7501ZM13.2501 17.5022C13.2501 17.9164 13.5858 18.2522 14.0001 18.2522C14.4143 18.2522 14.7501 17.9164 14.7501 17.5022H13.2501ZM10.7484 10.4993C10.7484 10.085 10.4126 9.74926 9.99839 9.74926C9.58417 9.74926 9.24839 10.085 9.24839 10.4993H10.7484ZM9.24839 17.5022C9.24839 17.9164 9.58417 18.2522 9.99839 18.2522C10.4126 18.2522 10.7484 17.9164 10.7484 17.5022H9.24839ZM4.49609 5.74759C4.08188 5.74759 3.74609 6.08338 3.74609 6.49759C3.74609 6.9118 4.08188 7.24759 4.49609 7.24759V5.74759ZM19.5023 7.24759C19.9166 7.24759 20.2523 6.9118 20.2523 6.49759C20.2523 6.08338 19.9166 5.74759 19.5023 5.74759V7.24759ZM7.28604 6.26042C7.15505 6.65338 7.36742 7.07812 7.76038 7.2091C8.15334 7.34009 8.57808 7.12772 8.70906 6.73476L7.28604 6.26042ZM8.54178 4.86491L9.25329 5.10208L9.25335 5.10191L8.54178 4.86491ZM10.4406 3.49634L10.4404 4.24634H10.4406V3.49634ZM13.5579 3.49634V4.24634L13.5588 4.24634L13.5579 3.49634ZM15.4587 4.86491L16.1704 4.62853L16.1702 4.62791L15.4587 4.86491ZM15.2891 6.73397C15.4197 7.12708 15.8442 7.33992 16.2373 7.20936C16.6304 7.07881 16.8432 6.65431 16.7127 6.2612L15.2891 6.73397ZM5.24672 9.49884V19.503H6.74672V9.49884H5.24672ZM5.24672 19.503C5.24672 21.0223 6.47831 22.2538 7.99755 22.2538V20.7538C7.30674 20.7538 6.74672 20.1938 6.74672 19.503H5.24672ZM7.99755 22.2538H16.0009V20.7538H7.99755V22.2538ZM16.0009 22.2538C17.5201 22.2538 18.7517 21.0223 18.7517 19.503H17.2517C17.2517 20.1938 16.6917 20.7538 16.0009 20.7538V22.2538ZM18.7517 19.503V9.49884H17.2517V19.503H18.7517ZM13.2501 10.4993V17.5022H14.7501V10.4993H13.2501ZM9.24839 10.4993V17.5022H10.7484V10.4993H9.24839ZM4.49609 7.24759H19.5023V5.74759H4.49609V7.24759ZM8.70906 6.73476L9.25329 5.10208L7.83027 4.62774L7.28604 6.26042L8.70906 6.73476ZM9.25335 5.10191C9.42355 4.59089 9.90177 4.24621 10.4404 4.24634L10.4407 2.74634C9.25622 2.74606 8.20452 3.50408 7.83021 4.62791L9.25335 5.10191ZM10.4406 4.24634H13.5579V2.74634H10.4406V4.24634ZM13.5588 4.24634C14.0979 4.24567 14.5767 4.59045 14.7471 5.10191L16.1702 4.62791C15.7956 3.50312 14.7425 2.74487 13.5569 2.74634L13.5588 4.24634ZM14.7469 5.1013L15.2891 6.73397L16.7127 6.2612L16.1704 4.62853L14.7469 5.1013Z"
        fill="#DE4343"
      />
    </svg>
  );
}
